export default "__VITE_ASSET__c0ab9b03__"